import React, { useEffect } from 'react';
import { RegularPolygon, Group } from 'react-konva';
import { useStyle } from '../../contexts/StyleContext'; 
import { useNotification } from '../../contexts/NotificationContext'; 
import { useTranslation } from 'react-i18next'; // Importing translation hook

import PetButton from './PetButton';

const Hexagon = ({ shapeId, shapeType, x, y, radius, color, buttons, rotation, draggable, onClick, selected, selectedButton, onButtonClick, onMouseEnter, onMouseLeave, hovered, hoveredItem, handleMouseEnterButton, handleMouseLeaveButton, onDragStart, onDragMove, onDragEnd, isDraggingShape, buttonLayout }) => {

  const { petButtonRadius = 10 } = useStyle() || {}; // Default radius to 10
  const { showNotification } = useNotification();
  const { t } = useTranslation(); // Hook to access translation

  const buttonPositions = calculateButtonPositions(0, 0, radius-30); // Buttons 20px outside the hexagon

  function calculateButtonPositions(centerX, centerY, radius) {
    const positions = [];
    const offsetAngleRad = Math.PI / 6; // 30 degrees in radians

    if (typeof centerX !== 'number' || typeof centerY !== 'number' || typeof radius !== 'number') {
 
      const extra = { centerX, centerY, radius };  
      showNotification({
        notification: t('errors.snackbar.InvalidPositionorSizeHexagon'),
        type: 'error',
        extra, 
        isException: false,
      });

      return [
        { x: 0, y: 0 },
        { x: 0, y: 0 }
      ];
    }
       // Add the center position first to have smallest number in the middle
       positions.push({ x: centerX, y: centerY });

    // Calculate the positions for the outer buttons
    for (let i = 0; i < 6; i++) {
        const angleRad = offsetAngleRad + (Math.PI / 3 * i); // Rotate each button 30 degrees from its original position
        const bx = centerX + radius * Math.cos(angleRad);
        const by = centerY + radius * Math.sin(angleRad);
        positions.push({ x: bx, y: by });
    }

    return positions;
}


  const handleSelect = (shapeId, e) => {
    
    // Prevent event bubbling if necessary
    e.cancelBubble = true;
    setTimeout(() => { // Ensures that the function runs after drag detection has completed.
      if (!isDraggingShape) {
          onClick(shapeId, e);
      }
    }, 0);
  };

  const handleButtonClick = (buttonLabel, shapeId, e) => {
    e.cancelBubble = true;
    onButtonClick(buttonLabel, shapeId, e); // Assuming `id` is the item's ID
  };


  return (
  
    <React.Fragment>
      <Group
        draggable={draggable}
        onDragStart={onDragStart}
        onDragMove={(e) => onDragMove(shapeId, e)} // Use the handleDragMove from Soundboard.js
        onDragEnd={(e) => onDragEnd(shapeId, e)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        rotation={rotation} // Apply the rotation here
        //onMouseDown={(e)=>handleSelect(shapeId, e)} // Select on click (mouse down)
        x={x}
        y={y}>   
      <RegularPolygon
        shapeType={shapeType}
        sides={6}
        radius={hovered || selected ? radius - 1 : radius} // Adjust radius when hovered or selected
        fill={color}
        onClick={(e)=>handleSelect(shapeId, e)}
        onPointerUp={(e)=>handleSelect(shapeId, e)}
        /*stroke={hovered && (hoveredItem.type === 'panel') ? '#dc03d1' : (selected ? '#e89b00' : 'transparent')}
        strokeWidth={3}*/
        stroke={hovered && (hoveredItem.type === 'panel') ? '#dc03d1' : (selected ? '#e89b00' : '#dedede')}
        strokeWidth={hovered && (hoveredItem.type === 'panel') ? 3 : (selected ? 3 : 1)}
        strokeScaleEnabled={false} // Ensures stroke width doesn't scale with the shape
        lineJoin="round" // Makes the corners rounded
        shadowColor={selected ? 'orange' : 'none'} // Yellow shadow to create a glow effect
        shadowBlur={selected ? 20 : 0} // Increase blur for a more pronounced glow
        shadowOffset={{ x: 0, y: 0 }} // No offset to ensure the glow is uniform
        shadowOpacity={selected ? 0.9 : 0} // Full opacity for the glow effect
      />

    {buttons.map((button, index) => (
      <PetButton
        key={button._id}
        id={button._id}
        buttonId={button._id}
        buttonLabel={button.buttonLabel}
        shapeId={shapeId} // Assuming `id` is the ID of the Hexagon component
        x={buttonPositions[index].x} // Accessing the x position from buttonPositions array
        y={buttonPositions[index].y} // Accessing the y position from buttonPositions array
        radius={parseFloat(petButtonRadius)}
        color={button.color}
        rotation={rotation} // This should be the rotation state of your Hexagon
        selected={selectedButton === button._id}//selectedButtonId === button._id
        onClick={(e) => handleButtonClick(button._id, shapeId, e)}
        onPointerUp={(e) => handleButtonClick(button._id, shapeId, e)} // Works for both touch and mouse
        onMouseEnter={(buttonId, e) => handleMouseEnterButton(buttonId, e)}
        onMouseLeave={handleMouseLeaveButton}
        hovered={hoveredItem.type === 'button' && hoveredItem.id === button._id}
      />
  ))}
      </Group> 
    </React.Fragment>
    
  );
};

export default Hexagon;
